/* eslint-disable consistent-return */
/* eslint-disable func-names */
/* eslint-disable no-self-compare */
/* eslint-disable no-extend-native */
import * as Yup from 'yup';
import moment from 'moment';
import { searchInArray } from 'utils/core';

Date.prototype.isValid = function () {
  return this.getTime() === this.getTime();
};

export const sexualityOptions = [
  { value: 'Feminino', label: 'Feminino' },
  { value: 'Masculino', label: 'Masculino' },
  { value: 'Nao binario', label: 'Não binário' },
  { value: 'Prefere nao opinar', label: 'Prefere não opinar' },
];

export const matitalStatusOptions = [
  { value: 'Casada(o)', label: 'Casada(o)' },
  { value: 'Em uma união estável', label: 'Em uma união estável' },
  { value: 'Divorciada(o)', label: 'Divorciada(o)' },
  { value: 'Noiva(o)', label: 'Noiva(o)' },
  { value: 'Separada(o)', label: 'Separada(o)' },
  { value: 'Solteira(o)', label: 'Solteira(o)' },
  { value: 'Viuva(o)', label: 'Viúva(o)' },
];

export const employeeLocalizationsOptions = [
  { value: '3.1. SERVICE', label: '3.1. SERVICE' },
  { value: '4.1. MKT', label: '4.1. MKT' },
  { value: '1.2. FINANCE', label: '1.2. FINANCE' },
  { value: '3.2. PRODUCT', label: '3.2. PRODUCT' },
  { value: '2.1. SALES', label: '2.1. SALES' },
  { value: '3.3. CONSULTING IOT', label: '3.3. CONSULTING IOT' },
  { value: '2.2. SALES ADM', label: '2.2. SALES ADM' },
  { value: '1.4. LEGAL', label: '1.4. LEGAL' },
  { value: '1.2.1. FINANCE INORGÂNICO', label: '1.2.1. FINANCE INORGÂNICO' },
  { value: '2.3. SALES LATAM', label: '2.3. SALES LATAM' },
  { value: '3.1.1. SERVICE INORGÂNICO', label: '3.1.1. SERVICE INORGÂNICO' },
  { value: '1.3. HR', label: '1.3. HR' },
  { value: '1.3.1. HR INORGÂNICO', label: '1.3.1. HR INORGÂNICO' },
  { value: '3.2.1. PRODUCT INORGÂNICO', label: '3.2.1. PRODUCT INORGÂNICO' },
];

export const defaultOptions = [
  { value: 'a', label: 'a' },
  { value: 'b', label: 'b' },
  { value: 'c', label: 'c' },
  { value: 'd', label: 'd' },
  { value: 'e', label: 'e' },
];

export const academicLevelOptions = [
  { value: 'Ensino fundamental', label: 'Ensino fundamental' },
  { value: 'Ensino Médio', label: 'Ensino Médio' },
  { value: 'Superior (Cursando)', label: 'Superior (Cursando)' },
  { value: 'Superior (Completo)', label: 'Superior (Completo)' },
  { value: 'Pós Graduação (Cursando)', label: 'Pós Graduação (Cursando)' },
  { value: 'Pós Graduação (Completo)', label: 'Pós Graduação (Completo)' },
  { value: 'Mestrado (Cursando)', label: 'Mestrado (Cursando)' },
  { value: 'Mestrado (Completo)', label: 'Mestrado (Completo)' },
  { value: 'Doutorado (Cursando)', label: 'Doutorado (Cursando)' },
  { value: 'Doutorado (Completo)', label: 'Doutorado (Completo)' },
  { value: 'Pós Doutorado (Cursando)', label: 'Pós Doutorado (Cursando)' },
  { value: 'Pós Doutorado (Completo)', label: 'Pós Doutorado (Completo)' },
];

export const validationSchema = Yup.object().shape({
  registrationNumber: Yup.string().required('Insira o número de matrícula'),
  sipNumber: Yup.string()
    .min(11, 'Número de PIS inválido')
    .max(14, 'Número de PIS inválido')
    .required('Insira o número do PIS'),
  // profession: Yup.string().required('Selecione um cargo para o funcionário'),
  employeeFunction: Yup.string().required('Selecione a função do funcionário'),
  step: Yup.string().required('Defina o step do funcionário'),
  seniorLevel: Yup.string().required(
    'Defina o nível de senioridade do funcionário',
  ),
  employeeCompany: Yup.string().required('Defina a empresa do funcionário'),
  // academicLevel: Yup.string().required('Defina a escolaridade do funcionário'),
  admissionDate: Yup.string()
    .required('Defina a data de admissão do funcionário')
    .nullable(),
  resignationDate: Yup.string().nullable(),
  ahgoraAppointment: Yup.bool(),
  coustCenter: Yup.string('Selecione o centro de custos do funcionário')
    .required('Selecione o centro de custos do funcionário')
    .nullable(),
  artificialAppointmentsDate: Yup.string().nullable(),
  directManager: Yup.string().nullable(),
  fullName: Yup.string()
    .min(5, 'Nome inválido. Insira o nome completo')
    .required('Insira o nome completo do funcionário'),
  // motherName: Yup.string().nullable(),
  // fatherName: Yup.string().nullable(),
  // nacionality: Yup.string().required('Insira a nacionalidade do funcionário'),
  birthDate: Yup.string()
    .required('Insira a data de aniversário do funcionário')
    .nullable(),
  // sexualGender: Yup.string().required('Selecione um gênero ao funcionário'),
  // maritalStatus: Yup.string().required('Selecione o status civil do funcionário'),
  // idNumber: Yup
  //   .string()
  //   .min(9, 'Número de RG inválido')
  //   .max(12, 'Número de RG inválido')
  //   .required('Insira o número de RG'),
  // pprNumber: Yup
  //   .string()
  //   .min(11, 'Número de CPF inválido')
  //   .max(14, 'Número de CPF inválido')
  //   .required('Insira o número do CPF'),
  email: Yup.string()
    .email('E-mail inválido')
    .required('Insira o e-mail do funcionário'),
  // cellphoneNumber: Yup.string().required('Insira o telefone celular'),
  // residenceNumber: Yup.string(),
  // commercialNumber: Yup.string().nullable(),
  country: Yup.string().required('Insira o país'),
  zipCode: Yup.string().nullable(),
  place: Yup.string().nullable(),
  houseNumber: Yup.string().nullable(),
  houseComplement: Yup.string().nullable(),
  neighborhood: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
});

export const getInitialValues = data => {
  const datGenerate = date => {
    const responseDate = new Date(moment(date));
    return responseDate.isValid() ? responseDate : null;
  };

  // const getArr = (arr, obj, type, field) => {
  //   const response = arr.filter(item => item[obj] === type);
  //   const [d] = response;
  //   return d ? d[field] : '';
  // };
  const extractInfo = arr => {
    const response = arr.find(searchInArray('id_tipo_documento', 'isEqual', 3));

    if (!response) return;

    const { documento } = response;
    return documento;
  };

  const finalObj = {
    registrationNumber: data ? data.matricula : '',
    // profession: data ? data.cargo : '',
    employeeFunction: data ? data.id_funcao : '',
    seniorLevel: data ? data.id_nivel : '',
    employeeCompany: data ? data.id_empresa : '',
    step: data ? data.step : '',
    sipNumber: data && data.documentos ? extractInfo(data.documentos) : '',
    // academicLevel: data ? data.grau_instrucao : '',
    admissionDate: datGenerate(data ? data.dt_admissao || '' : ''),
    resignationDate: datGenerate(data ? data.dt_demissao || '' : ''),
    ahgoraAppointment: data?.bate_ponto ?? false,
    coustCenter: data ? data.id_centro_de_custo : '',
    directManager: data?.id_gestor_direto ?? null,
    artificialAppointmentsDate: datGenerate(
      data?.dt_inicio_batidas_artificiais || '',
    ),
    fullName: data ? data.nome : '',
    // motherName: data ? data.nome_pai : '',
    // fatherName: data ? data.nome_mae : '',
    // nacionality: data ? data.nacionalidade : '',
    birthDate: datGenerate(data ? data.dt_nascimento || '' : ''),
    // sexualGender: data ? data.genero : '',
    // maritalStatus: data ? data.estado_civil : '',
    // idNumber: data ? getArr(data.documentos, 'id_tipo_documento', 1, 'documento') || '' : '',
    // pprNumber: data ? getArr(data.documentos, 'id_tipo_documento', 2, 'documento') || '' : '',
    // sipNumber: data ? getArr(data.documentos, 'id_tipo_documento', 3, 'documento') || '' : '',
    email: data ? data.email : '',
    // cellphoneNumber: data ? getArr(data.contatos, 'id_tipo_contato', 1, 'contato') || '' : '',
    // residenceNumber: data ? getArr(data.contatos, 'id_tipo_contato', 2, 'contato') || '' : '',
    // commercialNumber: data ? getArr(data.contatos, 'id_tipo_contato', 3, 'contato') || '' : '',
    zipCode: data ? data.cep : '',
    place: data ? data.logradouro : '',
    houseNumber: data ? data.numero : '',
    houseComplement: data ? data.complemento : '',
    neighborhood: data ? data.bairro : '',
    city: data ? data.cidade : '',
    state: data ? data.uf : '',
    country: data ? data.pais : '',
  };

  return finalObj;
};
